import { Location, SubmitFunction } from 'react-router';
import { useEffect, useState } from 'react';

interface StoreAdSourceProps {
  location: Location;
  submit: SubmitFunction;
  user_signed_in: boolean;
}

export const useStoreAttribution = ({
  location,
  submit,
  user_signed_in,
}: StoreAdSourceProps) => {
  const [updated, setUpdated] = useState(false);

  useEffect(() => {
    if (updated) return;

    const searchParams = new URLSearchParams(location.search);

    if (![...searchParams].length) return;

    const fbclid = searchParams.get('fbclid') || null;
    const ttclid = searchParams.get('ttclid') || null;
    const gclid = searchParams.get('gclid') || null;

    if (fbclid) {
      localStorage.setItem('flexcar_fb_click', fbclid);
      localStorage.setItem('flexcar_fb_click_time', Date.now().toString());
    } else if (ttclid) {
      localStorage.setItem('flexcar_tt_click', ttclid);
      localStorage.setItem('flexcar_tt_click_time', Date.now().toString());
    } else if (gclid) {
      localStorage.setItem('flexcar_g_click', gclid);
      localStorage.setItem('flexcar_g_click_time', Date.now().toString());
    }

    setUpdated(true);
  }, [location.search, updated]);

  useEffect(() => {
    if (updated && user_signed_in) {
      submit(
        {
          intent: 'store-attribution',
          fbclid: localStorage.getItem('flexcar_fb_click'),
          fb_date: localStorage.getItem('flexcar_fb_click_time'),
          ttclid: localStorage.getItem('flexcar_tt_click'),
          tt_date: localStorage.getItem('flexcar_tt_click_time'),
          gclid: localStorage.getItem('flexcar_g_click'),
          g_date: localStorage.getItem('flexcar_g_click_time'),
        },
        { method: 'post', navigate: false }
      );
    }
  }, [updated, submit, user_signed_in]);
};
